<template>
  <svg viewBox="-130 -100 500 500">
    <rect x="-130" y="-100" width="500" height="500" fill="#121010" />
    <g clip-path="url(#clip0_1401_86283)">
      <mask
        id="mask0_1401_86283"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="240"
        height="300">
        <path d="M240 0H0V300H240V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1401_86283)">
        <path d="M180 240H60V120H180V240Z" fill="#4B4646" />
        <path d="M180 60H60V240H180V60ZM240 300H0V0H240V300Z" fill="#F1ECEC" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1401_86283"><rect width="240" height="300" fill="white" /></clipPath>
    </defs>
  </svg>
</template>
